import { createAction } from 'redux-actions';

export const UPDATE_EMAIL_CONTACT = createAction('UPDATE_EMAIL_CONTACT');
export const UPDATE_EMAIL_CONTACT_START = createAction('UPDATE_EMAIL_CONTACT_START');
export const UPDATE_EMAIL_CONTACT_SUCCESS = createAction('UPDATE_EMAIL_CONTACT_SUCCESS');
export const UPDATE_EMAIL_CONTACT_ERROR = createAction('UPDATE_EMAIL_CONTACT_ERROR');
export const UPDATE_EMAIL_CONTACT_FINALLY = createAction('UPDATE_EMAIL_CONTACT_FINALLY');
export const CHANGE_STATUS_FALSE = createAction('CHANGE_STATUS_FALSE');

export const GET_KC_USER = createAction("GET_KC_USER");
export const GET_KC_USER_START = createAction("GET_KC_USER_START");
export const GET_KC_USER_SUCCESS = createAction("GET_KC_USER_SUCCESS");
export const GET_KC_USER_ERROR = createAction("GET_KC_USER_ERROR");
export const GET_KC_USER_FINALLY = createAction("GET_KC_USER_FINALLY");
export const SET_KC_USER = createAction("SET_KC_USER");

export const CHANGE_EMAIL_SSO = createAction("CHANGE_EMAIL_SSO");
export const CHANGE_EMAIL_SSO_START = createAction("CHANGE_EMAIL_SSO_START");
export const CHANGE_EMAIL_SSO_SUCCESS = createAction("CHANGE_EMAIL_SSO_SUCCESS");
export const CHANGE_EMAIL_SSO_ERROR = createAction("CHANGE_EMAIL_SSO_ERROR");
export const CHANGE_EMAIL_SSO_FINALLY = createAction("CHANGE_EMAIL_SSO_FINALLY");

export const CLEAR_EMAIL_SSO_ERROR = createAction("CLEAR_EMAIL_SSO_ERROR");

export const SET_EMAIL_MODAL_STATUS = createAction("SET_EMAIL_MODAL_STATUS")
